var map = {
	"./ABW.png": 1651,
	"./AFG.png": 1730,
	"./AGO.png": 15860,
	"./ALB.png": 98985,
	"./ALG.png": 34771,
	"./AND.png": 54189,
	"./ANG.png": 15819,
	"./ANT.png": 33470,
	"./ARE.png": 89290,
	"./ARG.png": 77017,
	"./ARM.png": 65456,
	"./ARU.png": 55538,
	"./ASA.png": 993,
	"./ASM.png": 95217,
	"./ATG.png": 26097,
	"./AUS.png": 85664,
	"./AUT.png": 43348,
	"./AZE.png": 7776,
	"./BAH.png": 19469,
	"./BAN.png": 80758,
	"./BAR.png": 21724,
	"./BDI.png": 36758,
	"./BEL.png": 65534,
	"./BEN.png": 51804,
	"./BER.png": 4587,
	"./BFA.png": 57675,
	"./BGD.png": 20027,
	"./BGR.png": 77163,
	"./BHR.png": 35662,
	"./BHS.png": 84533,
	"./BHU.png": 79342,
	"./BIH.png": 98986,
	"./BIZ.png": 16715,
	"./BLR.png": 73479,
	"./BLZ.png": 57777,
	"./BMU.png": 936,
	"./BOL.png": 30552,
	"./BOT.png": 65967,
	"./BRA.png": 75044,
	"./BRB.png": 46174,
	"./BRN.png": 34124,
	"./BRU.png": 78804,
	"./BTN.png": 76790,
	"./BUL.png": 29235,
	"./BUR.png": 95793,
	"./BWA.png": 5645,
	"./CAF.png": 6397,
	"./CAM.png": 15009,
	"./CAN.png": 57001,
	"./CAY.png": 71583,
	"./CGO.png": 61487,
	"./CHA.png": 82332,
	"./CHE.png": 97505,
	"./CHI.png": 46469,
	"./CHL.png": 90908,
	"./CHN.png": 4464,
	"./CIV.png": 15399,
	"./CMR.png": 58164,
	"./COD.png": 19124,
	"./COG.png": 68431,
	"./COK.png": 22285,
	"./COL.png": 5933,
	"./COM.png": 38342,
	"./CPV.png": 42859,
	"./CRC.png": 86582,
	"./CRI.png": 99091,
	"./CRO.png": 18327,
	"./CUB.png": 62621,
	"./CYM.png": 80616,
	"./CYP.png": 36005,
	"./CZE.png": 88799,
	"./DEN.png": 16686,
	"./DEU.png": 34442,
	"./DJI.png": 6167,
	"./DMA.png": 98943,
	"./DNK.png": 51366,
	"./DOM.png": 78844,
	"./DZA.png": 17139,
	"./ECU.png": 94759,
	"./EGY.png": 34669,
	"./ERI.png": 26467,
	"./ESA.png": 3267,
	"./ESP.png": 50329,
	"./EST.png": 63606,
	"./ETH.png": 85399,
	"./FIJ.png": 56344,
	"./FIN.png": 26701,
	"./FJI.png": 28684,
	"./FRA.png": 24773,
	"./FSM.png": 84259,
	"./GAB.png": 51004,
	"./GAM.png": 3451,
	"./GBR.png": 94951,
	"./GBS.png": 58834,
	"./GEO.png": 87224,
	"./GEQ.png": 91661,
	"./GER.png": 54618,
	"./GHA.png": 99627,
	"./GIN.png": 70520,
	"./GMB.png": 13167,
	"./GNB.png": 27583,
	"./GNQ.png": 6120,
	"./GRC.png": 26955,
	"./GRD.png": 36585,
	"./GRE.png": 88398,
	"./GRN.png": 5145,
	"./GTM.png": 58530,
	"./GUA.png": 85944,
	"./GUI.png": 83848,
	"./GUM.png": 40732,
	"./GUY.png": 68306,
	"./HAI.png": 48230,
	"./HKG.png": 86382,
	"./HND.png": 39575,
	"./HON.png": 70224,
	"./HRV.png": 62337,
	"./HTI.png": 84428,
	"./HUN.png": 14612,
	"./IDN.png": 40803,
	"./INA.png": 20069,
	"./IND.png": 97178,
	"./IRI.png": 81738,
	"./IRL.png": 91593,
	"./IRN.png": 77101,
	"./IRQ.png": 60785,
	"./ISL.png": 49121,
	"./ISR.png": 17295,
	"./ISV.png": 75036,
	"./ITA.png": 60586,
	"./IVB.png": 76153,
	"./JAM.png": 27285,
	"./JOR.png": 8334,
	"./JPN.png": 63436,
	"./KAZ.png": 57990,
	"./KEN.png": 95602,
	"./KGZ.png": 41812,
	"./KHM.png": 55613,
	"./KIR.png": 82940,
	"./KNA.png": 17834,
	"./KOR.png": 63450,
	"./KSA.png": 9640,
	"./KUW.png": 30520,
	"./KWT.png": 99321,
	"./LAO.png": 70370,
	"./LAT.png": 54791,
	"./LBA.png": 95392,
	"./LBN.png": 93544,
	"./LBR.png": 22035,
	"./LBY.png": 40641,
	"./LCA.png": 86214,
	"./LES.png": 50712,
	"./LIB.png": 99369,
	"./LIE.png": 1039,
	"./LKA.png": 41906,
	"./LSO.png": 20310,
	"./LTU.png": 44732,
	"./LUX.png": 7914,
	"./LVA.png": 98433,
	"./MAD.png": 30715,
	"./MAR.png": 31071,
	"./MAS.png": 40698,
	"./MAW.png": 18853,
	"./MCO.png": 83581,
	"./MDA.png": 55379,
	"./MDG.png": 82221,
	"./MDV.png": 35156,
	"./MEX.png": 47695,
	"./MEX.svg.png": 4926,
	"./MGL.png": 96150,
	"./MHL.png": 26786,
	"./MKD.png": 26109,
	"./MLI.png": 27796,
	"./MLT.png": 56534,
	"./MMR.png": 54749,
	"./MNE.png": 21087,
	"./MNG.png": 56319,
	"./MON.png": 93723,
	"./MOZ.png": 98729,
	"./MRI.png": 10514,
	"./MRT.png": 34943,
	"./MTN.png": 97904,
	"./MWI.png": 35511,
	"./MYA.png": 59137,
	"./MYS.png": 75455,
	"./NAM.png": 69757,
	"./NCA.png": 65302,
	"./NED.png": 98485,
	"./NEP.png": 16289,
	"./NER.png": 90566,
	"./NGA.png": 14312,
	"./NGR.png": 30157,
	"./NIC.png": 84636,
	"./NIG.png": 88051,
	"./NLD.png": 87831,
	"./NOR.png": 45883,
	"./NPL.png": 12508,
	"./NRU.png": 31709,
	"./NZL.png": 11499,
	"./OMA.png": 66926,
	"./OMN.png": 25908,
	"./PAK.png": 90574,
	"./PAN.png": 16805,
	"./PAR.png": 43190,
	"./PER.png": 76507,
	"./PHI.png": 47767,
	"./PHL.png": 39770,
	"./PLE.png": 41251,
	"./PLW.png": 84884,
	"./PNG.png": 80868,
	"./POL.png": 27692,
	"./POR.png": 86056,
	"./PRI.png": 8126,
	"./PRK.png": 63602,
	"./PRT.png": 39621,
	"./PRY.png": 32803,
	"./PSE.png": 81982,
	"./PUR.png": 63257,
	"./QAT.png": 26164,
	"./ROU.png": 67418,
	"./RSA.png": 65113,
	"./RUS.png": 7394,
	"./RWA.png": 34019,
	"./SAM.png": 3092,
	"./SAU.png": 39318,
	"./SDN.png": 29970,
	"./SEN.png": 79266,
	"./SEY.png": 24616,
	"./SGP.png": 96361,
	"./SIN.png": 85917,
	"./SKN.png": 67014,
	"./SLB.png": 70762,
	"./SLE.png": 47306,
	"./SLO.png": 26588,
	"./SLV.png": 5164,
	"./SMR.png": 54507,
	"./SOL.png": 69008,
	"./SOM.png": 36423,
	"./SRB.png": 65062,
	"./SRI.png": 58990,
	"./STP.png": 36345,
	"./SUD.png": 11347,
	"./SUI.png": 72712,
	"./SUR.png": 51785,
	"./SVK.png": 83176,
	"./SVN.png": 22910,
	"./SWE.png": 49562,
	"./SWZ.png": 85905,
	"./SYC.png": 4968,
	"./SYR.png": 37687,
	"./TAN.png": 39999,
	"./TCD.png": 25024,
	"./TGA.png": 7816,
	"./TGO.png": 44239,
	"./THA.png": 97207,
	"./TJK.png": 82761,
	"./TKM.png": 20776,
	"./TLS.png": 65414,
	"./TOG.png": 86822,
	"./TPE.png": 31057,
	"./TTO.png": 73526,
	"./TUN.png": 76365,
	"./TUR.png": 40883,
	"./TUV.png": 52236,
	"./TZA.png": 95387,
	"./UAE.png": 10850,
	"./UGA.png": 57238,
	"./UKR.png": 59207,
	"./URU.png": 25064,
	"./URY.png": 62632,
	"./USA.png": 37626,
	"./UZB.png": 31657,
	"./VAN.png": 47953,
	"./VCT.png": 5296,
	"./VEN.png": 12621,
	"./VIE.png": 93489,
	"./VIN.png": 14356,
	"./VNM.png": 54734,
	"./VUT.png": 32142,
	"./WSM.png": 21843,
	"./YEM.png": 57712,
	"./ZAF.png": 78236,
	"./ZAM.png": 48770,
	"./ZIM.png": 9256,
	"./ZMB.png": 11648,
	"./ZWE.png": 41006
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 50299;